import { useState } from "react";
import { createPayRuleProfile } from "./api";
import { PayRuleBuilder, type PayRuleDraft } from "./components/pay-rule-builder";
import { PageHeader, useToast } from "@/components/design";

export function PayRulesPage() {
  const { toast } = useToast();
  const [name, setName] = useState("");
  const [stackingMode, setStackingMode] =
    useState<"HIGHEST_MULTIPLIER_WINS" | "STACK_MULTIPLIERS" | "CUSTOM_PRIORITY">(
      "HIGHEST_MULTIPLIER_WINS",
    );
  const [rules, setRules] = useState<PayRuleDraft[]>([]);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await createPayRuleProfile({ name, stackingMode, rules });
      toast({ variant: "success", title: "Pay rule profile saved" });
      setName("");
      setRules([]);
    } catch (err) {
      toast({
        variant: "error",
        title: "Failed to save profile",
        description: err instanceof Error ? err.message : "Unknown error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader
        title="Pay Rules"
        description="Configure overtime, premiums, and multipliers with the Werkio Rules Engine."
      />
      <PayRuleBuilder
        name={name}
        stackingMode={stackingMode}
        rules={rules}
        onNameChange={setName}
        onStackingModeChange={setStackingMode}
        onRulesChange={setRules}
        onSubmit={() => void handleSubmit()}
        submitting={submitting}
      />
    </div>
  );
}
